import { useState } from "react";
import { Grid, Box, TextField, Button, Typography, Paper, Divider } from "@mui/material";
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from '@mui/icons-material/X';
import TikTokIcon from '../../common/TikTokIcon';
import { updateProfileRedes } from "../../../actions/profile";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import PropTypes from "prop-types";

import { useDispatch } from "react-redux";

const MainRedes = ({
  data, cambiarData
}) => {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);

  const toggleEdit = () => {
    const newState = !isEditing;
    setIsEditing(newState);
  }

  const guardarRedes = async () => {
    const info = {
      instagram: data.instagram,
      facebook: data.facebook,
      tiktok: data.tiktok,
      youtube: data.youtube,
      twitter: data.twitter,
      linkedin: data.linkedin,
    };
    await dispatch(updateProfileRedes(info));
    setIsEditing(false)
  }

  const renderSocialItem = (icon, label, key, placeholder) => (
    <Box sx={{ display: "flex", alignItems: "flex-start", mb: 3 }}>
      <Box className="social-icon-square" sx={{ bgcolor: "transparent", mt: 0.5 }}>
        {icon}
      </Box>
      <Box sx={{ width: "100%" }}>
        <Typography variant="body2" color="text.secondary" mb={0.5}>
          {label}:
        </Typography>
        {
          isEditing ? (
            <TextField
              id={key}
              placeholder={placeholder}
              size="small"
              fullWidth
              value={data[key]}
              onChange={(e) => cambiarData(key, e.target.value)}
            />
          ) : (
            <Typography
              fontWeight="bold"
              color="text.primary"
              noWrap
              sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
            >
              { data[key] ? data[key] : "No agregado" }
            </Typography>
          )
        }
      </Box>
    </Box>
  );

  return (
    <Grid container spacing={1} mb={2} mt={2} size={12}>
      {/* Header Section */}
      <Grid size={12} container justifyContent="space-between" alignItems="center" mb={3}>
        <Grid>
          <Typography variant="h3" color="primary">
            Redes sociales
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Si tienes redes sociales que te gustaría compartir sobre tu servicio agregalas aquí.
          </Typography>
        </Grid>
        <Grid hidden={isEditing}>
          <Button
            variant="contained"
            startIcon={<DriveFileRenameOutlineIcon />}
            color='secondary'
            onClick={toggleEdit}
          >
            Editar
          </Button>
        </Grid>
      </Grid>

      <Paper sx={{ padding: 3, width: "100%" }}>
        <Grid container size={12} spacing={0} justifyContent="space-between">
          {/* Column 1: Instagram & Facebook */}
          <Grid size={{ xs: 12, md: 3.5 }} mr={2}>
            {renderSocialItem(<InstagramIcon sx={{ color: "primary.main", fontSize: 30 }} />, "Instagram", "instagram", "@usuario")}
            {renderSocialItem(<FacebookIcon sx={{ color: "primary.main", fontSize: 30 }} />, "Facebook", "facebook", "Usuario")}
          </Grid>

          {/* Divider 1 */}
          <Grid  sx={{ display: { xs: 'none', md: 'block' } }}>
            <Divider orientation="vertical" sx={{ height: '100%' }} />
          </Grid>

          {/* Column 2: YouTube & X */}
          <Grid size={{ xs: 12, md: 3.5 }} mx={2}>
            {renderSocialItem(<YouTubeIcon sx={{ color: "primary.main", fontSize: 30 }} />, "YouTube", "youtube", "Canal")}
            {renderSocialItem(<XIcon sx={{ color: "primary.main", fontSize: 30 }} />, "X", "twitter", "@usuario")}
          </Grid>

          {/* Divider 2 */}
          <Grid sx={{ display: { xs: 'none', md: 'block' } }}>
            <Divider orientation="vertical" sx={{ height: '100%' }} />
          </Grid>

          {/* Column 3: TikTok & LinkedIn */}
          <Grid size={{ xs: 12, md: 3.5 }} pl={2}>
            {renderSocialItem(<TikTokIcon sx={{ color: "primary.main", fontSize: 30 }} />, "TikTok", "tiktok", "@usuario")}
            {renderSocialItem(<LinkedInIcon sx={{ color: "primary.main", fontSize: 30 }} />, "LinkedIn", "linkedin", "Usuario")}
          </Grid>
        </Grid>

        {/* Save Button */}
        {
          isEditing && (
            <Grid size={12} container justifyContent="flex-end" mt={3} spacing={2}>
              <Button
                variant="outlined"
                size="large"
                onClick={() => setIsEditing(false)}
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={guardarRedes}
              >
                Guardar
              </Button>
            </Grid>
          )
        }
      </Paper>
    </Grid>
  );
}

MainRedes.propTypes = {
  data: PropTypes.object.isRequired,
  redes: PropTypes.object,
  cambiarData: PropTypes.func.isRequired,
};

export default MainRedes;